import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import { goToRelativeRoute } from "modules/Services";
import { getIsAccountConfigurationEnabled } from "Utils/ACLStoreUtils";
export default store => ({
  path: "teachers",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "TeacherSetup/modules/Module"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "TeacherSetup/components/BulkActions/modules/BulkActionsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const module2 = importedModule1;
        const bulkActionsModule = importedModule2;
        const reducer = module2.default;
        const key = module2.NAME;

        injectReducer(store, {
          key,
          reducer,
        });
        injectReducer(store, {
          key: bulkActionsModule.NAME,
          reducer: bulkActionsModule.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (
      _.last(nextState.routes).path == "teachers" &&
      !getIsAccountConfigurationEnabled()
    ) {
      const route = getNextMenuRoute("TEACHER_SETUP");
      if (route) {
        const goToNewRoute = goToRelativeRoute({
          route: getRelativePath(route),
        });
        store?.dispatch(goToNewRoute);
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
